import React, { useState } from 'react'
import { Grid, Button } from '@mui/material'
import moment from 'moment'
import useStyles from './styles'

function List(props) {
    const classes = useStyles()
    const [, setrRefresh] = useState(0)
    let ratingListData = props.ratingTab === 0 ? props.satisfaction.strengths : props.satisfaction.weakPoints

    const getBtnColor = (id) => {
        let status = props.reasonRating.indexOf(id)
        if (status === -1) return "inherit"
        else return props.ratingTab === 0 ? "primary" : "secondary"
    }

    const btnHandleFunc = (vReasonSatisfactionTitle) => {
        props.setReasonRating(vReasonSatisfactionTitle)
        setrRefresh(moment().format('x'))
    }

    return (
        <Grid container spacing={1} className={classes.reasonList}>
            {ratingListData.map((obj, index) => {
                let color = getBtnColor(obj.vReasonSatisfactionTitle)
                return (
                    <Grid key={index} item xs={6} md={6}>
                        <Button
                            color={color}
                            fullWidth
                            variant="outlined"
                            onClick={() => btnHandleFunc(obj.vReasonSatisfactionTitle)}
                            className={classes.reasonListBtn}
                        >
                            {obj.vReasonSatisfactionTitle}
                        </Button>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default List

